
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/great-members",
      function () {
        return require("private-next-pages/great-members.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/great-members"])
      });
    }
  